import {Vector} from "./vector.js";

let screenSize = new Vector();

// Record current screen size
//
// This function gets the screen size from the window. Call this function once per tick.
//
// Returns true iff the screen was resized since last call.
export function recordScreenSize() {
	if (screenSize.x !== window.innerWidth || screenSize.y !== window.innerHeight) {
		screenSize.x = window.innerWidth;
		screenSize.y = window.innerHeight;
		return true;
	}
	return false;
}

// Return the last recorded screen size, as a vector in pixels
export function getScreenSize() {
	return new Vector(screenSize);
}

// TODO: Move the mouse code here
